
import { defineComponent, PropType, ref, watch } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'
import { useI18n } from 'vue-i18n'

type ColumnStructType = {
  id: number
  number: string
  name: string
  order: string
}

export default defineComponent({
  components: {
    draggable: VueDraggableNext
  },
  props: {
    list: {
      type: [] as PropType<Array<any>>,
      default: () => {
        return []
      }
    },
    columnStruct: {
      type: Object as PropType<ColumnStructType>,
      required: true
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    },
    maxListHeight: {
      type: String,
      default: '400px'
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const orderList = ref(props.list)
    const submitSort = () => {
      orderList.value.forEach((item, index) => {
        item[props.columnStruct.order] = index + 1
      })
      context.emit('submit')
    }
    const resetSort = () => {
      orderList.value.sort((a, b) => a[props.columnStruct.order] - b[props.columnStruct.order])
      context.emit('reset')
    }
    watch(() => props.list, (list) => {
      orderList.value = list
    })
    return {
      t,
      orderList,
      submitSort,
      resetSort
    }
  }
})

